import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from 'react-router-dom';

const Rows = (props: any) => {
  const navigate = useNavigate();
  const dataRow = props.item;

  const handleRowClick = () => {
    navigate(`/master/email-view?id=${dataRow.id}`);
  };

  const getStatus = (status: string) => {
    let result = '';
    switch (status) {
      case '0':
        result = '無効';
        break;
      case '1':
        result = '有効';
        break;
      case '2':
        result = '承認待ち';
        break;
      default:
        break;
    }
    return result;
  };

  return (
    <TableRow
      hover
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        cursor: 'pointer',
      }}
      onClick={handleRowClick}
    >
      <TableCell>{dataRow.name}</TableCell>
      <TableCell>{dataRow.category}</TableCell>
      <TableCell>{getStatus(dataRow.status)}</TableCell>
      <TableCell>{dataRow.updated_at}</TableCell>
      <TableCell>{dataRow.updated_by}</TableCell>
      <TableCell>{dataRow.approved_by}</TableCell>
    </TableRow>
  );
};

export default Rows;
